// Глобальный конфиг для API
// Используется для хранения callback-функции logout и редиректа
class ApiConfig {
    constructor() {
        this.logoutCallback = null;
        this.redirectCallback = null;
    }

    setLogoutCallback(callback) {
        this.logoutCallback = callback;
    }

    setRedirectCallback(callback) {
        this.redirectCallback = callback;
    }

    getLogoutCallback() {
        return this.logoutCallback;
    }

    getRedirectCallback() {
        return this.redirectCallback;
    }

    executeLogout() {
        if (typeof this.logoutCallback === 'function') {
            this.logoutCallback();
        }
        // После logout перенаправляем на страницу входа
        if (typeof this.redirectCallback === 'function') {
            this.redirectCallback('/login');
        }
    }
}

export default new ApiConfig();



// WEBPACK FOOTER //
// ./src/ApiConfig.js